/**
 * Bulk Loading Area view. View for loading area, fetches all manifested  bulk.
 * Initalizes drag and drop for all bulk cargo request.
 *
 */

var VRC = VRC || {};

VRC.BulkLoadingAreaView = (function () {
	var _loadingAreaColumnNum = 6;

	var _marginPercent = 0.5;
	var _size;

	var _queries = {
		container: '#bulk-state-loading'
	};

	var showLoading = function () {
		var $container = $(_queries.container);

		var content = WELL.Handlebars.VRC.bulk_loading_area_loading();
		$container.html(content);
	};

	var init = function () {

		var bulkTankRequests = VRC.BulkCargoRequestManager.toJson();

		render(bulkTankRequests);
	};

	var attachDraggable = function () {
		var $bulkTankRequests = interact('.bulk_deck.requests .bulk_tank');

		$bulkTankRequests.draggable({
			autoScroll: true,
			onstart: function (event) {

				var target = event.target;
				target.style.zIndex = '1000';
				target.classList.add('drag-element');

				var containerId = $(target).attr('data-container-id');
				var cargoRequest = VRC.BulkCargoRequestManager.getBulkCargoRequestById(containerId);
				if (VRC.BulkCompatibility.hasComponent()) {
					checkBulkMixCompatibility(cargoRequest);
				}

				//allBulkTanks.popover('hide');
				//disableClickHandling();
			},
			onmove: function dragMoveListener (event) {
				var target = event.target;
				var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
				var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
				target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
				target.setAttribute('data-x', x);
				target.setAttribute('data-y', y);
			},
			// call this function on every dragend event
			onend: function (event) {
				var target = event.target;
				target.classList.remove('drag-element');
				target.style.zIndex = 'auto';
				target.style.transform = 'translate(0, 0)';
				target.setAttribute('data-x', '0');
				target.setAttribute('data-y', '0');
				clearBulkMixOverlay();
				setTimeout(function () {
					//enableClickHandling();
				}, 0);
			}
		});
	};

	var checkBulkMixCompatibility = function (bulkRequest) {
		var requestItemGroupName = bulkRequest.getItemGroupId();

		var bulkTanks = VRC.BulkTankManager.getBulkTanks();
		_.each(bulkTanks, function (bulkTank) {
			var bulkTankId = bulkTank.getBulkTankId();
			var lastLoadAction = bulkTank.getLastAction();
			var tankItemGroupName = lastLoadAction ? lastLoadAction.getItemGroupId() : undefined;

			var rule = VRC.BulkCompatibility.canMixBulk(requestItemGroupName, tankItemGroupName);
			var $bulkTank = VRC.BulkStateView.getBulkTankElement(bulkTankId);
			$bulkTank.css({backgroundColor: rule.rule.colour})
		});
	};

	var clearBulkMixOverlay = function () {
		var bulkTanks = VRC.BulkTankManager.getBulkTanks();
		_.each(bulkTanks, function (bulkTank) {
			var bulkTankId = bulkTank.getBulkTankId();
			var colour = bulkTank.getTankColour();
			var $bulkTank = VRC.BulkStateView.getBulkTankElement(bulkTankId);
			$bulkTank.css({backgroundColor: colour})
		});

	};

	var createContext = function (bulkTankRequests) {

		_.each(bulkTankRequests, function (request) {
			// request.tankShape = request['valueUnit'] && request['valueUnit'] === 'mt' ? 'circle' : 'square';
		});

		_size = VRC.BulkViewUtil.calculateSize(_marginPercent, _loadingAreaColumnNum);

		var portColors = findPortColorsInRequests(bulkTankRequests);

		return {
			bulkTankRequests: bulkTankRequests,
			size: _size,
			margin: _marginPercent,
			portColors: portColors,
			units: VRC.MasterDataService.getBulkValueUnitsAsArray()
		};
	};

	var reRenderPortColors = function () {
		var bulkTankRequests = VRC.BulkCargoRequestManager.toJson();

		var portColors = findPortColorsInRequests(bulkTankRequests);
		var html = Handlebars.partials['port_colors'](portColors);
		var $portColors = getPortColors();
		$portColors.replaceWith(html);
	};

	var getBulkRequestElement = function (containerId) {
		return $(_queries.container).find('.bulk_tank[data-container-id=' + containerId + ']');
	};
	var getPortColors = function () {
		return $(_queries.container).find('.port-color-codes');
	};

	var reRenderBulkRequest = function (bulkRequest) {
		var containerId = bulkRequest.getContainerId();
		var bulkRequestJson = bulkRequest.toJson();

		bulkRequestJson.main = {
			size: _size,
			margin: _marginPercent
		};

		var html = Handlebars.partials['bulk_cargo_request'](bulkRequestJson);
		var $bulkRequest = getBulkRequestElement(containerId);
		$bulkRequest.replaceWith(html);
		reRenderPortColors();
	};

	var removeBulkRequest = function (bulkRequest) {
		var containerId = bulkRequest.getContainerId();

		var $bulkRequest = getBulkRequestElement(containerId);
		$bulkRequest.remove();
		reRenderPortColors();

	};

	var findPortColorsInRequests = function (requests) {
		var portColors = _.chain(requests).groupBy(function (request) {
			return request.displayPort;
		}).map(function (group) {
			var item = _.first(group);
			return {
				portName: item.displayPort,
				portColorCode: item.portColorCode
			};
		}).sortBy(function (request) {
			return request.portColorCode;
		}).value();

		return portColors;
	};

	var render = function (bulkTankRequests) {
		var ctx = createContext(bulkTankRequests);
		var $container = $(_queries.container);

		var content = WELL.Handlebars.VRC.bulk_loading_area(ctx);
		$container.html(content);

		attachDraggable();

		//setupClickHandling();
		//setupDragHandling();
	};

	return {
		init: init,
		showLoading: showLoading,
		reRenderBulkRequest: reRenderBulkRequest,
		removeBulkRequest: removeBulkRequest,
		render: render
	}
})();
